// Mock data for Reserva Cancún - Private Transfers
// NOTE: All data here is MOCKED for the frontend-only teaser.

export const IMAGES = {
  heroA:
    "https://images.unsplash.com/photo-1630252522843-1b772124e874?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxDYW5jdW4lMjB0dXJxdW9pc2UlMjBiZWFjaCUyMGFlcmlhbHxlbnwwfHx8fDE3ODcwOTA3Mjl8MA&ixlib=rb-4.1.0&q=85",
  heroB:
    "https://images.pexels.com/photos/11423491/pexels-photo-11423491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  van:
    "https://images.unsplash.com/photo-1787028331201-75a0abb8ab0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxwYXNzZW5nZXIlMjB2YW58ZW58MHx8fHwxNzg3MDkwNjMwfDA&ixlib=rb-4.1.0&q=85",
  suv:
    "https://images.unsplash.com/photo-1735620731955-b047a7122892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxibGFjayUyMFNVVnxlbnwwfHx8fDE3ODcwOTA2MzB8MA&ixlib=rb-4.1.0&q=85",
  luxury:
    "https://images.pexels.com/photos/19871521/pexels-photo-19871521.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  luxuryB:
    "https://images.unsplash.com/photo-1664686448782-d8f4af31e45b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcHJpbnRlcnxlbnwwfHx8fDE3ODcwOTA2MzB8MA&ixlib=rb-4.1.0&q=85",
  tulum:
    "https://images.unsplash.com/photo-1622870129889-f7e0ba2603a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxUdWx1bSUyMHJ1aW5zfGVufDB8fHx8MTc4NzA5MDY2MHww&ixlib=rb-4.1.0&q=85",
  playa:
    "https://images.unsplash.com/photo-1509233725247-49e657c54213?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxQbGF5YSUyMGRlbCUyMENhcm1lbnxlbnwwfHx8fDE3ODcwOTA2NjB8MA&ixlib=rb-4.1.0&q=85",
  cancun:
    "https://images.unsplash.com/photo-1711220465753-2450b31ea318?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxDYW5jdW4lMjBiZWFjaHxlbnwwfHx8fDE3ODcwOTA2NjB8MA&ixlib=rb-4.1.0&q=85",
  akumal:
    "https://images.pexels.com/photos/32594143/pexels-photo-32594143.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cenote:
    "https://images.pexels.com/photos/33667438/pexels-photo-33667438.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  chichen:
    "https://images.unsplash.com/photo-1620636607286-087f5a7b5716?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxDaGljaGVuJTIwSXR6YSUyMHB5cmFtaWR8ZW58MHx8fHwxNzg3MDkwNzAyfDA&ixlib=rb-4.1.0&q=85",
  dolphins:
    "https://images.unsplash.com/photo-1440020143730-090579c4d53c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxkb2xwaGlucyUyMHN3aW18ZW58MHx8fHwxNzg3MDkwNzAyfDA&ixlib=rb-4.1.0&q=85",
};

// Contact / WhatsApp (click-to-chat)
export const CONTACT_PHONE = "+52 998 790 7699";
export const WHATSAPP_NUMBER = "529987907699"; // country code 52 + 10 digits
export const buildWhatsAppLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message || "")}`;

// Airports (origins). Place names are NOT translated.
export const AIRPORTS = [
  { id: "cun", name: "Cancún International Airport (CUN)" },
  { id: "cozumel", name: "Cozumel Airport (CZM)" },
];

// Destinations across the Riviera Maya with ROUND TRIP base prices (USD).
// Van range ~150-226 ; Luxury range ~1200-5000 depending on the leg.
export const DESTINATIONS = [
  { id: "cancun-hz", name: "Cancún Hotel Zone", minutes: 20, vanRT: 150, luxRT: 1200 },
  { id: "puerto-morelos", name: "Puerto Morelos", minutes: 35, vanRT: 165, luxRT: 1600 },
  { id: "playa-del-carmen", name: "Playa del Carmen", minutes: 55, vanRT: 180, luxRT: 2400 },
  { id: "puerto-aventuras", name: "Puerto Aventuras", minutes: 70, vanRT: 195, luxRT: 3200 },
  { id: "akumal", name: "Akumal", minutes: 85, vanRT: 205, luxRT: 3800 },
  { id: "tulum", name: "Tulum", minutes: 100, vanRT: 226, luxRT: 5000 },
];

// Popular hotels per destination (place/brand names NOT translated).
export const HOTELS = {
  "cancun-hz": ["Hard Rock Hotel Cancún", "Riu Palace Las Americas", "Live Aqua Beach Resort", "Nizuc Resort & Spa"],
  "puerto-morelos": ["Dreams Natura Resort", "Now Jade Riviera Cancún", "Hyatt Ziva Riviera Cancún"],
  "playa-del-carmen": ["Grand Hyatt Playa del Carmen", "Hotel Xcaret México", "Thompson Playa del Carmen", "Mahekal Beach Resort"],
  "puerto-aventuras": ["Catalonia Riviera Maya", "Dreams Puerto Aventuras", "Omni Puerto Aventuras"],
  "akumal": ["Secrets Akumal Riviera Maya", "Bahía Príncipe Akumal", "Grand Sirenis Riviera Maya"],
  "tulum": ["Bahía Príncipe Tulum", "Dreams Tulum Resort", "Hotel Bardo Tulum", "La Zebra Tulum"],
};

// Vehicle categories. Multipliers applied over destination base price.
export const VEHICLE_TYPES = [
  {
    id: "van",
    tier: "van",
    image: IMAGES.van,
    capacity: 8,
    priceKey: "vanRT",
    multiplier: 1,
    popular: true,
  },
  {
    id: "suv",
    tier: "suv",
    image: IMAGES.suv,
    capacity: 5,
    priceKey: "vanRT",
    multiplier: 2.1,
    popular: false,
  },
  {
    id: "luxury",
    tier: "luxury",
    image: IMAGES.luxury,
    capacity: 14,
    priceKey: "luxRT",
    multiplier: 1,
    popular: false,
  },
];

export const TOURS = [
  { id: "cenote", image: IMAGES.cenote, price: 129, tagKey: "snorkel" },
  { id: "chichen", image: IMAGES.chichen, price: 159, tagKey: "ruins" },
  { id: "dolphins", image: IMAGES.dolphins, price: 189, tagKey: "adventure" },
  { id: "akumalTour", image: IMAGES.akumal, price: 99, tagKey: "snorkel" },
];

export const STATS_CLIENTS = 9124483;

// i18n dictionary. Place & hotel names are never translated.
export const translations = {
  es: {
    // nav
    navTransfers: "Traslados Aeropuerto",
    navHotel: "Hotel a Hotel",
    navTours: "Tours y Actividades",
    navAirport: "Encuéntranos en el Aeropuerto",
    navContact: "Contacto",
    bookNow: "Reservar",
    // hero
    heroTitle: "Reserva tu Transporte Privado al Aeropuerto",
    heroBrand: "con Reserva Cancún",
    heroSub: "Traslados privados en Cancún y la Riviera Maya. Puntualidad, confort y tarifas claras.",
    clientsServed: "CLIENTES ATENDIDOS",
    // search
    roundTrip: "Viaje Redondo",
    oneWayArrival: "Solo Llegada",
    oneWayDeparture: "Solo Salida",
    hotelToHotel: "Hotel a Hotel",
    origin: "Origen",
    destination: "Destino",
    selectDestination: "Selecciona un destino",
    selectOrigin: "Selecciona origen",
    hotel: "Hotel",
    selectHotel: "Selecciona tu hotel",
    arrivalDate: "Fecha de Llegada",
    departureDate: "Fecha de Salida",
    pickDate: "Elige una fecha",
    passengers: "Pasajeros",
    findTransfer: "BUSCAR TRASLADO",
    // results
    resultsTitle: "Vehículos disponibles",
    resultsFor: "para",
    upTo: "Hasta",
    pax: "pasajeros",
    perTripRound: "Precio viaje redondo",
    perTripOne: "Precio solo ida",
    selectVehicle: "Seleccionar",
    included: "Incluye",
    incAC: "Aire acondicionado",
    incMeet: "Recepción con letrero",
    incWater: "Agua embotellada",
    incFlight: "Monitoreo de vuelo",
    incVip: "Servicio VIP privado",
    incLead: "Chofer bilingüe",
    travelTime: "Tiempo aprox.",
    min: "min",
    completeSearch: "Completa el buscador para ver precios y vehículos disponibles.",
    // vehicle names
    vanName: "Van Privada Estándar",
    vanDesc: "Ideal para familias y grupos. Cómoda y espaciosa.",
    suvName: "SUV Suburban Premium",
    suvDesc: "Confort premium para grupos pequeños.",
    luxuryName: "Luxury Sprinter VIP",
    luxuryDesc: "Máximo lujo con asientos de piel y amenidades.",
    // tours
    toursTitle: "Cosas por hacer en Cancún y la Riviera Maya",
    toursSub: "Comienza tu búsqueda con las mejores tarifas.",
    from: "Desde",
    perPerson: "por persona",
    reserve: "Reservar",
    snorkel: "Snorkel",
    ruins: "Ruinas Mayas",
    adventure: "Aventura",
    tourCenote: "Cenote y Arrecife Snorkel",
    tourChichen: "Chichén Itzá Privado",
    tourDolphins: "Nado con Delfines",
    tourAkumal: "Tortugas en Akumal",
    // destinations
    destTitle: "Traslados Privados al Aeropuerto",
    destSub: "Reserva tu transporte a los principales destinos de la Riviera Maya",
    privateTransfers: "Traslados Privados",
    // features strip
    feat1: "Confirmación inmediata",
    feat1d: "Recibe tu reserva al instante por correo.",
    feat2: "Cancelación gratuita",
    feat2d: "Cancela sin costo hasta 48 horas antes.",
    feat3: "Sin cargos ocultos",
    feat3d: "El precio que ves es el precio final.",
    feat4: "Soporte 24/7",
    feat4d: "Estamos contigo antes, durante y después.",
    // footer
    footerAbout: "Nosotros",
    aboutUs: "Acerca de",
    faqs: "Preguntas Frecuentes",
    footerTransfers: "Traslados",
    footerTours: "Tours y Actividades",
    support: "Atención al Cliente",
    fromUsa: "Desde USA o Canadá marca",
    rights: "Todos los derechos reservados.",
    tagline: "Traslados privados de confianza en Cancún desde 1999.",
    // toast
    searchDone: "Encontramos vehículos disponibles para tu viaje.",
    booked: "¡Vehículo seleccionado! (demo)",
    fillFields: "Por favor completa origen, destino y fecha.",
    completeBooking: "Completa tu reserva",
    fullName: "Nombre completo",
    fullNamePh: "Ej. Juan Pérez",
    phone: "Teléfono",
    notes: "Notas (opcional)",
    notesPh: "Número de vuelo, hora de llegada, etc.",
    confirmBooking: "CONFIRMAR RESERVA",
    bookingRequired: "Completa nombre, email y teléfono.",
    bookingSuccess: "¡Reserva confirmada!",
    bookingError: "No se pudo crear la reserva. Intenta de nuevo.",
    bookingConfirmed: "¡Reserva confirmada!",
    bookingRef: "Referencia:",
    total: "Total",
    close: "Cerrar",
    flightNumber: "Número de vuelo (opcional)",
    flightNumberPh: "Ej. AA1234",
    checkFlight: "Verificar vuelo",
    flightChecking: "Verificando...",
    flightAirline: "Aerolínea",
    flightArrivalAirport: "Aeropuerto",
    scheduledArrival: "Llegada programada",
    estimatedArrival: "Llegada estimada",
    terminal: "Terminal",
    pickupReady: "Chofer listo para recogerte",
    pickupNote: "Coordinaremos a tu chofer para que te espere al salir.",
    statusOnTime: "En horario",
    statusSlightDelay: "Ligero retraso",
    statusDelayed: "Retrasado",
    flightSimNote: "Estimación simulada (demo) — no son datos de vuelo en vivo.",
    flightInvalid: "Número de vuelo no válido. Ej. AA1234",
    flightError: "No se pudo verificar el vuelo. Intenta de nuevo.",
    policiesLink: "Políticas de cancelación",
    policiesTitle: "Políticas de reservación y cancelación",
    policiesIntro: "Lee atentamente nuestras políticas antes de confirmar tu servicio.",
    backHome: "Volver al inicio",
    whatsappCta: "Escríbenos por WhatsApp",
    whatsappMsg: "Hola, me gustaría reservar un traslado privado en Cancún.",
    termsLink: "Términos y Condiciones",
    privacyLink: "Política de Privacidad",
    contactTitle: "Contáctanos",
    contactSub: "¿Tienes dudas? Escríbenos y te responderemos a la brevedad.",
    yourName: "Tu nombre",
    yourEmail: "Tu email",
    yourPhone: "Tu teléfono",
    yourMessage: "Tu mensaje",
    sendMessage: "ENVIAR MENSAJE",
    contactSent: "¡Mensaje enviado! Gracias por contactarnos.",
    contactError: "No se pudo enviar. Intenta de nuevo.",
    contactFill: "Completa nombre, email y mensaje.",
    adminTitle: "Panel de Reservas",
    adminBookings: "Reservas",
    adminMessages: "Mensajes",
    noData: "Sin registros aún.",
  },
  en: {
    navTransfers: "Airport Transfers",
    navHotel: "Hotel to Hotel",
    navTours: "Tours & Activities",
    navAirport: "Find us at Airport",
    navContact: "Contact",
    bookNow: "Book Now",
    heroTitle: "Book your Private Airport Transportation",
    heroBrand: "with Reserva Cancún",
    heroSub: "Private transfers in Cancún & the Riviera Maya. On time, comfortable and transparent rates.",
    clientsServed: "CLIENTS SERVED",
    roundTrip: "Round Trip",
    oneWayArrival: "One Way Arrival",
    oneWayDeparture: "One Way Departure",
    hotelToHotel: "Hotel to Hotel",
    origin: "Origin",
    destination: "Destination",
    selectDestination: "Select a destination",
    selectOrigin: "Select origin",
    hotel: "Hotel",
    selectHotel: "Select your hotel",
    arrivalDate: "Arrival Date",
    departureDate: "Departure Date",
    pickDate: "Pick a date",
    passengers: "Passengers",
    findTransfer: "FIND A TRANSFER",
    resultsTitle: "Available vehicles",
    resultsFor: "for",
    upTo: "Up to",
    pax: "passengers",
    perTripRound: "Round trip price",
    perTripOne: "One way price",
    selectVehicle: "Select",
    included: "Included",
    incAC: "Air conditioning",
    incMeet: "Meet & greet",
    incWater: "Bottled water",
    incFlight: "Flight monitoring",
    incVip: "Private VIP service",
    incLead: "Bilingual driver",
    travelTime: "Approx. time",
    min: "min",
    completeSearch: "Complete the search above to see prices and available vehicles.",
    vanName: "Standard Private Van",
    vanDesc: "Great for families and groups. Comfortable and roomy.",
    suvName: "Premium Suburban SUV",
    suvDesc: "Premium comfort for small groups.",
    luxuryName: "Luxury Sprinter VIP",
    luxuryDesc: "Ultimate luxury with leather seats and amenities.",
    toursTitle: "Things to do in Cancún & the Riviera Maya",
    toursSub: "Start your search with a look at the best rates.",
    from: "From",
    perPerson: "per person",
    reserve: "Book",
    snorkel: "Snorkel",
    ruins: "Mayan Ruins",
    adventure: "Adventure",
    tourCenote: "Cenote & Reef Snorkel",
    tourChichen: "Chichén Itzá Private",
    tourDolphins: "Swim with Dolphins",
    tourAkumal: "Turtles in Akumal",
    destTitle: "Private Airport Transfers",
    destSub: "Book your transportation to the top Riviera Maya destinations",
    privateTransfers: "Private Transfers",
    feat1: "Instant confirmation",
    feat1d: "Get your booking right away by email.",
    feat2: "Free cancellation",
    feat2d: "Cancel at no cost up to 48 hours before.",
    feat3: "No hidden fees",
    feat3d: "The price you see is the final price.",
    feat4: "24/7 support",
    feat4d: "We're with you before, during and after.",
    footerAbout: "About",
    aboutUs: "About Us",
    faqs: "FAQs",
    footerTransfers: "Transfers",
    footerTours: "Tours & Activities",
    support: "Customer Support",
    fromUsa: "From USA or Canada dial",
    rights: "All rights reserved.",
    tagline: "Trusted private transfers in Cancún since 1999.",
    searchDone: "We found available vehicles for your trip.",
    booked: "Vehicle selected! (demo)",
    fillFields: "Please complete origin, destination and date.",
    completeBooking: "Complete your booking",
    fullName: "Full name",
    fullNamePh: "e.g. John Smith",
    phone: "Phone",
    notes: "Notes (optional)",
    notesPh: "Flight number, arrival time, etc.",
    confirmBooking: "CONFIRM BOOKING",
    bookingRequired: "Please complete name, email and phone.",
    bookingSuccess: "Booking confirmed!",
    bookingError: "Could not create the booking. Please try again.",
    bookingConfirmed: "Booking confirmed!",
    bookingRef: "Reference:",
    total: "Total",
    close: "Close",
    flightNumber: "Flight number (optional)",
    flightNumberPh: "e.g. AA1234",
    checkFlight: "Check flight",
    flightChecking: "Checking...",
    flightAirline: "Airline",
    flightArrivalAirport: "Airport",
    scheduledArrival: "Scheduled arrival",
    estimatedArrival: "Estimated arrival",
    terminal: "Terminal",
    pickupReady: "Driver ready to pick you up",
    pickupNote: "We'll coordinate your driver to wait for you at arrivals.",
    statusOnTime: "On time",
    statusSlightDelay: "Slight delay",
    statusDelayed: "Delayed",
    flightSimNote: "Simulated estimate (demo) — not live flight data.",
    flightInvalid: "Invalid flight number. e.g. AA1234",
    flightError: "Could not check the flight. Please try again.",
    policiesLink: "Cancellation policies",
    policiesTitle: "Reservation and cancellation policies",
    policiesIntro: "Please read our policies carefully before confirming your service.",
    backHome: "Back to home",
    whatsappCta: "Chat with us on WhatsApp",
    whatsappMsg: "Hi, I'd like to book a private transfer in Cancún.",
    termsLink: "Terms & Conditions",
    privacyLink: "Privacy Policy",
    contactTitle: "Contact us",
    contactSub: "Have questions? Write to us and we'll reply shortly.",
    yourName: "Your name",
    yourEmail: "Your email",
    yourPhone: "Your phone",
    yourMessage: "Your message",
    sendMessage: "SEND MESSAGE",
    contactSent: "Message sent! Thanks for reaching out.",
    contactError: "Could not send. Please try again.",
    contactFill: "Please complete name, email and message.",
    adminTitle: "Bookings Dashboard",
    adminBookings: "Bookings",
    adminMessages: "Messages",
    noData: "No records yet.",
  },
};

export const TOUR_NAME_KEYS = {
  cenote: "tourCenote",
  chichen: "tourChichen",
  dolphins: "tourDolphins",
  akumalTour: "tourAkumal",
};

export const VEHICLE_NAME_KEYS = {
  van: { name: "vanName", desc: "vanDesc" },
  suv: { name: "suvName", desc: "suvDesc" },
  luxury: { name: "luxuryName", desc: "luxuryDesc" },
};

// Reservation & cancellation policies content (provided by client).
export const POLICIES = {
  es: [
    {
      title: "General",
      items: [
        "Todos los precios están en dólares estadounidenses.",
        "Traslado privado, sin paradas, con aire acondicionado y conductor que habla inglés.",
        "Algunos tours/traslados/productos requieren un depósito o el pago completo al momento de la reserva. Se aceptan tarjetas de débito y crédito a través de un sistema de pago seguro en línea, en la mayoría de los casos.",
        "Le proporcionaremos un comprobante de confirmación por escrito con el saldo pendiente, por correo electrónico, para cada parte de sus servicios.",
        "En traslados/tours, cualquier parada adicional debe programarse antes de la fecha del servicio con un costo adicional. Las paradas extra deben especificarse en su comprobante.",
        "Ofrecemos asientos de seguridad orientados hacia el frente para niños de hasta 40 lb sin costo adicional. No los garantizamos, aunque los proporcionamos en el 99% de los casos.",
        "La ley federal de transporte y el seguro requieren que el número de personas en el vehículo no exceda la cantidad indicada en su comprobante. Nos reservamos el derecho de negar pasajeros adicionales.",
      ],
    },
    {
      title: "Cambios y cancelaciones",
      items: [
        "Los servicios de traslado deben cancelarse o modificarse antes de las 2 p.m. del día anterior para recibir un reembolso completo de cualquier depósito o pago total realizado.",
        "Los servicios de tour deben cancelarse o modificarse antes de las 2 p.m. del día anterior para recibir un reembolso completo de cualquier depósito o pago total realizado.",
        "Las cancelaciones pueden realizarse por correo electrónico, chat en vivo o WhatsApp con al menos 48 horas de anticipación antes de la fecha del servicio. Si es con 24 horas o menos, ¡llámenos!",
        "Los cambios de último minuto requieren una llamada directa a nuestro servicio al cliente.",
        "Debe hablar personalmente con nuestro personal de atención al cliente. No permita que el agente de viajes del hotel o el concierge llamen por usted. Todos hablamos inglés.",
        "Le proporcionaremos un número de cancelación. Escríbalo y consérvelo hasta recibir su reembolso.",
        "En la mayoría de los casos, el reembolso se emite dentro de las 72 horas.",
        "Contacte a nuestro servicio al cliente si necesita hacer cambios. Todos los datos de contacto están en su comprobante. Una vez realizado el cambio, se le enviará un nuevo comprobante por correo electrónico.",
        "Hacemos seguimiento a los vuelos de llegada, pero cualquier cambio de vuelo debe ser reportado de inmediato a nuestro servicio al cliente.",
        "Es su responsabilidad revisar la información en sus comprobantes de confirmación. Lea su comprobante cuidadosamente.",
        "Los cambios o cancelaciones por causas fuera de su control serán evaluados por nuestro departamento de atención al cliente. Somos muy flexibles en cuanto a vuelos.",
        "La garantía de traslado para vuelos con llegada retrasada tiene un tiempo máximo de espera de 4 horas. Ayudamos a nuestros clientes de todas las maneras posibles para llegar a nuevos arreglos. Nos reservamos el derecho de negar cambios entre las 9 p.m. y las 5 a.m. en servicios de llegada.",
        "La garantía de traslado en salidas/traslados entre hoteles permite una espera de 15 minutos antes de considerarlo no presentado.",
        "Los traslados privados le permiten cambiar la hora de recogida de regreso para su comodidad. Sin embargo, si el cambio es muy justo para alcanzar su vuelo, será bajo su propia responsabilidad.",
      ],
    },
    {
      title: "Responsabilidades",
      items: [
        "Todos los objetos personales, equipaje, artículos frágiles o de valor (como dispositivos electrónicos, billeteras, bolsos, joyas, documentos de viaje, medicamentos) son responsabilidad del cliente. Asegúrese de llevar consigo todas sus pertenencias al entrar o salir del vehículo.",
        "Los vehículos son libres de humo.",
        "Nos reservamos el derecho de negar el servicio a pasajeros que insulten a nuestro personal, tengan conductas abusivas o estén bajo el efecto de alcohol o drogas.",
        "Las mascotas pueden viajar en una jaula. Los perros de servicio están exentos.",
        "RSV Transfers se empeña por llevar a cada pasajero a su destino de manera segura y puntual. Sin embargo, hay circunstancias fuera de nuestro control que pueden ocasionar retrasos; causados por accidentes a lo largo de la autopista, clima severo, averías o demoras en el estacionamiento del aeropuerto, por los que no nos hacemos responsables. Abordaremos cada caso de la forma más profesional posible para evitar cualquier pérdida o costo extra.",
        "Nuestros vehículos están asegurados. Cualquier accidente ocurrido mientras un pasajero esté a bordo de nuestros vehículos, debe ser reportado y manejado conforme a las políticas de la aseguradora. Abandonar el lugar de los hechos o no seguir las instrucciones de la aseguradora, nos libera automáticamente de cualquier responsabilidad.",
      ],
    },
  ],
  en: [
    {
      title: "General",
      items: [
        "All prices are in US dollars.",
        "Private transfer, non-stop, with air conditioning and an English-speaking driver.",
        "Some tours/transfers/products require a deposit or full payment at the time of booking. Debit and credit cards are accepted through a secure online payment system, in most cases.",
        "We will provide a written confirmation voucher with the balance due, by email, for each part of your services.",
        "For transfers/tours, any additional stop must be scheduled before the service date at an additional cost. Extra stops must be specified on your voucher.",
        "We offer forward-facing safety seats for children up to 40 lb at no additional cost. We do not guarantee them, although we provide them in 99% of cases.",
        "Federal transportation law and insurance require that the number of people in the vehicle does not exceed the amount indicated on your voucher. We reserve the right to refuse additional passengers.",
      ],
    },
    {
      title: "Changes and cancellations",
      items: [
        "Transfer services must be cancelled or modified before 2 p.m. the day before to receive a full refund of any deposit or full payment made.",
        "Tour services must be cancelled or modified before 2 p.m. the day before to receive a full refund of any deposit or full payment made.",
        "Cancellations can be made by email, live chat or WhatsApp at least 48 hours before the service date. If it is 24 hours or less, call us!",
        "Last-minute changes require a direct call to our customer service.",
        "You must speak personally with our customer service staff. Do not let the hotel travel agent or concierge call for you. We all speak English.",
        "We will provide you with a cancellation number. Write it down and keep it until you receive your refund.",
        "In most cases, the refund is issued within 72 hours.",
        "Contact our customer service if you need to make changes. All contact details are on your voucher. Once the change is made, a new voucher will be emailed to you.",
        "We track arriving flights, but any flight change must be reported immediately to our customer service.",
        "It is your responsibility to review the information on your confirmation vouchers. Read your voucher carefully.",
        "Changes or cancellations due to causes beyond your control will be evaluated by our customer service department. We are very flexible regarding flights.",
        "The transfer guarantee for delayed-arrival flights has a maximum waiting time of 4 hours. We help our clients in every possible way to reach new arrangements. We reserve the right to refuse changes between 9 p.m. and 5 a.m. on arrival services.",
        "The transfer guarantee on departures/hotel-to-hotel transfers allows a 15-minute wait before it is considered a no-show.",
        "Private transfers allow you to change the return pickup time for your convenience. However, if the change is too tight to catch your flight, it will be at your own risk.",
      ],
    },
    {
      title: "Responsibilities",
      items: [
        "All personal items, luggage, fragile or valuable items (such as electronic devices, wallets, bags, jewelry, travel documents, medications) are the client's responsibility. Make sure to take all your belongings with you when entering or leaving the vehicle.",
        "The vehicles are smoke-free.",
        "We reserve the right to refuse service to passengers who insult our staff, behave abusively, or are under the influence of alcohol or drugs.",
        "Pets may travel in a crate. Service dogs are exempt.",
        "RSV Transfers strives to take every passenger to their destination safely and on time. However, there are circumstances beyond our control that may cause delays; caused by accidents along the highway, severe weather, breakdowns or delays in the airport parking, for which we are not responsible. We will handle each case as professionally as possible to avoid any loss or extra cost.",
        "Our vehicles are insured. Any accident that occurs while a passenger is on board our vehicles must be reported and handled in accordance with the insurance company's policies. Leaving the scene or not following the insurance company's instructions automatically releases us from any liability.",
      ],
    },
  ],
};
